import { render, staticRenderFns } from "./addCard.vue?vue&type=template&id=20b9094c&scoped=true"
import script from "./addCard.vue?vue&type=script&lang=js"
export * from "./addCard.vue?vue&type=script&lang=js"
import style0 from "./addCard.vue?vue&type=style&index=0&id=20b9094c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b9094c",
  null
  
)

export default component.exports